export function cleanStatus(s: string): string {
  return s.replaceAll("_", "-").toLowerCase()
}
